module.exports = __webpack_public_path__ + "static/bluunext-bold-webfont-d6ede42d7f28e497bf8b55398daa5ef9.woff";